import { WizardStepType } from '../types'

export const WizardStepTypeToNumber = (step?: WizardStepType) => {
    switch (step) {
        default:
        case 'SimpleInfo':
            return 0
        case 'Packages':
            return 1
        case 'Invoicing':
            return 2
        case 'Summary':
            return 3
        case 'Finish':
            return 4
    }
}
